import {
  TAYS_POLKU_REDIRECT_URL_ERROR,
  TAYS_POLKU_REDIRECT_URL_RECEIVE,
  TAYS_POLKU_REDIRECT_URL_REQUEST,
} from '../tayspolku/actions';

export const initialState = {
  data: [],
  isFetching: false,
  url: null,
  error: null,
};

export const reducer = (state, action) => {
  let { type, payload } = action;

  switch (type) {
    case TAYS_POLKU_REDIRECT_URL_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case TAYS_POLKU_REDIRECT_URL_RECEIVE: {
      return {
        ...state,
        url: payload,
        isFetching: false,
      };
    }
    case TAYS_POLKU_REDIRECT_URL_ERROR: {
      return {
        ...state,
        error: payload,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
